export default {
      id: "phone-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#phone",
      toString: function () {
        return this.url;
      }
    }